import { render } from "./LoaderOval.vue?vue&type=template&id=2664d8e9&scoped=true"
import script from "./LoaderOval.vue?vue&type=script&lang=js"
export * from "./LoaderOval.vue?vue&type=script&lang=js"

import "./LoaderOval.vue?vue&type=style&index=0&id=2664d8e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2664d8e9"]])

export default __exports__